import { defineComponent as _defineComponent } from 'vue'
import { ProductType } from '@/components/Billing/billing-types';
import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingFeaturesSection from '@/components/Billing/BillingFeaturesSection.vue';
// @ts-ignore
import TeamFeaturesSectionHeader from '@/components/Billing/TeamFeatures/TeamFeaturesSectionHeader.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingTeamFeatures',
  props: {
    selectedTeamFeatureProduct: null,
    currentAccountTeamFeatureProduct: null,
    isCurrentTeamTasksVirtuallyUnlimited: { type: Boolean }
  },
  emits: ["select-plan"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'select-plan', planId: string): void;
}), expose: any, slots: any, attrs: any }) {



const { teamPlans } = useBilling();
const productType = ProductType.TeamFeatures;

return { __sfc: true,emit, teamPlans, productType, BillingFeaturesSection, TeamFeaturesSectionHeader }
}

})